"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { ChevronRight } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { buildWorkspaceMenuItems } from "@/components/layouts/sidebar/workspace-menu-items";
import { WorkspaceMenuWorkflowsSection } from "@/components/layouts/sidebar/workspace-menu-workflows-section";
import { partitionWorkspaceViews } from "@/components/layouts/sidebar/workspace-view-partition";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { SidebarGroup, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem, useSidebar } from "@/components/ui/sidebar";
import { TOUR_TARGETS } from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { useWorkspacePermissionCheck } from "@/hooks/use-workspace-permission-check";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { cn } from "@/lib/utils";
import { getViewIcon } from "@/lib/utils/icons";
import { SessionActivity, sessionActivityHandler } from "@/lib/utils/session-activity";
const MENU_ACTIVE_CLASSNAME = "h-12 text-sm sm:text-[13px] sm:h-10 transition-colors duration-200 data-[active=true]:rounded-l-none data-[active=true]:rounded-r-none data-[active=true]:border-l-3 data-[active=true]:border-l-background";
const FinancialsViewIcon = getViewIcon("financials");
export function WorkspaceMenuList() {
  const $ = _c(12);
  const {
    open
  } = useSidebar();
  const pathname = usePathname();
  const {
    workspace,
    currentView
  } = useCurrentWorkspace();
  const {
    check
  } = useWorkspacePermissionCheck();
  let t0;
  if ($[0] !== check) {
    t0 = check("automation", "*", {
      defaultValue: true
    });
    $[0] = check;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const canViewAutomations = t0;
  let t1;
  if ($[2] !== workspace?.activeViews) {
    t1 = workspace?.activeViews || [];
    $[2] = workspace?.activeViews;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentViews = t1;
  const hasViews = currentViews.length > 0;
  let t2;
  if ($[4] !== currentViews) {
    t2 = partitionWorkspaceViews(currentViews);
    $[4] = currentViews;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    dashboardViews,
    workflowViews
  } = t2;
  const workspaceMenuItems = buildWorkspaceMenuItems(dashboardViews, currentView);
  const hasActiveFinancialsGroup = workspaceMenuItems.some(_temp);
  const [isFinancialsOpen, setIsFinancialsOpen] = useState(hasActiveFinancialsGroup);
  let t3;
  if ($[6] !== hasActiveFinancialsGroup) {
    t3 = [hasActiveFinancialsGroup];
    $[6] = hasActiveFinancialsGroup;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(() => {
    if (hasActiveFinancialsGroup) {
      setIsFinancialsOpen(true);
    }
  }, t3);
  let t4;
  if ($[8] !== pathname) {
    t4 = url => {
      sessionActivityHandler.recordActivity({
        pageActivity: [{
          action: SessionActivity.pageActivityActions.PAGE_NAVIGATION,
          payload: {
            currentPagePath: pathname,
            nextPagePath: url
          },
          time: new Date().toISOString()
        }],
        pagePath: pathname
      });
    };
    $[8] = pathname;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handlePageNavigationActivity = t4;
  const t5 = hasViews && <><SidebarGroup id={TOUR_TARGETS.sidebarWorkspaceNav}><SidebarMenu className="-mt-0.5">{workspaceMenuItems.map(menuItem_0 => {
          if (menuItem_0.kind === "group") {
            if (!open) {
              return <SidebarMenuItem key={menuItem_0.id}><DropdownMenu><DropdownMenuTrigger asChild={true}><SidebarMenuButton className={cn(MENU_ACTIVE_CLASSNAME, "border-l-0!")} isActive={menuItem_0.isActive} tooltip={{
                      arrow: {
                        className: "fill-sidebar-accent"
                      },
                      children: `${menuItem_0.label} (${menuItem_0.items.length} views)`,
                      className: "bg-sidebar-accent text-sidebar-accent-foreground"
                    }}>{FinancialsViewIcon && <FinancialsViewIcon />}<span>{menuItem_0.label}</span></SidebarMenuButton></DropdownMenuTrigger><DropdownMenuContent align="start" className="min-w-48 bg-sidebar border-sidebar-accent/40 text-sidebar-foreground" side="right"><DropdownMenuLabel className="text-sidebar-foreground">{menuItem_0.label}</DropdownMenuLabel><DropdownMenuSeparator className="bg-sidebar-accent/40" />{menuItem_0.items.map(childItem => {
                      const url_0 = `/${workspace?.id}/${childItem.view.name.toLowerCase()}`;
                      return <DropdownMenuItem asChild={true} className={cn("cursor-pointer text-xs hover:text-sidebar-accent-foreground hover:bg-sidebar-accent", childItem.isActive && "bg-sidebar-accent text-sidebar-accent-foreground")} key={childItem.view.id}><Link href={url_0} onClick={() => {
                          handlePageNavigationActivity(url_0);
                        }} prefetch={false}><span>{childItem.label}</span></Link></DropdownMenuItem>;
                    })}</DropdownMenuContent></DropdownMenu></SidebarMenuItem>;
            }
            return <SidebarMenuItem key={menuItem_0.id}><Collapsible className="data-[state=open]:border-sidebar-border/20 data-[state=open]:border-t data-[state=open]:rounded-md data-[state=open]:bg-black/20" onOpenChange={setIsFinancialsOpen} open={isFinancialsOpen}><SidebarMenuButton asChild={true} className={cn(MENU_ACTIVE_CLASSNAME, !open && "border-l-0!")} isActive={menuItem_0.isActive} tooltip={{
                  arrow: {
                    className: "fill-sidebar-accent"
                  },
                  children: menuItem_0.label,
                  className: "bg-sidebar-accent text-sidebar-accent-foreground"
                }}><CollapsibleTrigger>{FinancialsViewIcon && <FinancialsViewIcon />}<span>{menuItem_0.label}</span><ChevronRight className={cn("ml-auto transition-transform duration-200 group-data-[collapsible=icon]:hidden", isFinancialsOpen && "rotate-90")} /></CollapsibleTrigger></SidebarMenuButton><CollapsibleContent className="border-t border-sidebar-border/20"><SidebarMenuSub className="border-l-0 px-0 mx-4 gap-0">{menuItem_0.items.map(childItem_0 => {
                      const url_1 = `/${workspace?.id}/${childItem_0.view.name.toLowerCase()}`;
                      return <SidebarMenuSubItem key={childItem_0.view.id}><SidebarMenuSubButton asChild={true} className="text-xs px-3.5" isActive={childItem_0.isActive}><Link href={url_1} onClick={() => {
                            handlePageNavigationActivity(url_1);
                          }} prefetch={false}><span>{childItem_0.label}</span></Link></SidebarMenuSubButton></SidebarMenuSubItem>;
                    })}</SidebarMenuSub></CollapsibleContent></Collapsible></SidebarMenuItem>;
          }
          const ViewIcon = getViewIcon(menuItem_0.view.name);
          const url_2 = `/${workspace?.id}/${menuItem_0.view.name.toLowerCase()}`;
          return <SidebarMenuItem key={menuItem_0.view.id}><SidebarMenuButton asChild={true} className={cn(MENU_ACTIVE_CLASSNAME, !open && "border-l-0!")} isActive={menuItem_0.isActive} onClick={() => {
              handlePageNavigationActivity(url_2);
            }} tooltip={{
              arrow: {
                className: "fill-sidebar-accent"
              },
              children: menuItem_0.label,
              className: "bg-sidebar-accent text-sidebar-accent-foreground"
            }}><Link href={url_2} prefetch={false}>{ViewIcon && <ViewIcon />}<span>{menuItem_0.label}</span></Link></SidebarMenuButton></SidebarMenuItem>;
        })}</SidebarMenu></SidebarGroup>{workspace?.id ? <WorkspaceMenuWorkflowsSection canViewAutomations={canViewAutomations} menuButtonClassName={MENU_ACTIVE_CLASSNAME} onNavigate={handlePageNavigationActivity} open={open} views={workflowViews} workspaceId={workspace.id} /> : null}</>;
  let t6;
  if ($[10] !== t5) {
    t6 = <>{t5}</>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(menuItem) {
  return menuItem.kind === "group" && menuItem.isActive;
}